/*document.addEventListener('alpine:initialized', () => {
  document.querySelectorAll('[x-data]').forEach((el) => {
    const data = Alpine.$data(el);
    if (data && typeof data.handleSearchSubmit === 'function') {
      data.handleSearchSubmit = function (event) {
        const form = event.target;
        const input = form.querySelector('input[name="q"]');
        if (input && input.value.trim().length > 0) {
          const term = input.value.trim();
          const isLikelySku = /\d/.test(term) && !/\s/.test(term);
          if (isLikelySku) {
            input.value = `${term} OR variants.sku:${term}`;
          }
        }
      };
    }
  });
});*/
document.querySelectorAll('[x-data]').forEach((el) => {
  const data = Alpine.$data(el);
  if (data && typeof data.handleSearchSubmit === 'function') {
    data.handleSearchSubmit = function (event) {
      const form = event.target;
      const input = form.querySelector('input[name="q"]');
      if (input && input.value.trim().length > 0) {
        const term = input.value.trim();
        const isLikelySku = /\d/.test(term) && !/\s/.test(term);
        if (isLikelySku) {
          input.value = `${term} OR variants.sku:${term}`;
        }
      }
    };
  }
});